module.exports = __webpack_public_path__ + "img/cases_page_header.8fdde6f5.png";